import { useAppState } from '../../client/providers/AppProvider';
import React, { useCallback } from 'react';
import { NeedsOnboardingInformation, usePageRequireAuth } from '../../client/hooks';
import { DashboardFullPageLoading } from '../../components/common/GenericFullPageLoading';
import { DashboardLayout } from '../../components/common/layout/DashboardLayout';
import { Espin_Role_Enum } from 'generated/spin-graphql';
import { ParentProfileViews } from '../../components/dashboard/profile-views/ParentProfileViews';

import CollegeProfileViews from 'components/dashboard/profile-views/CollegeProfileViews';
import PlayerProfileViews from '../../components/dashboard/profile-views/PlayerProfileViews';
import HighSchoolProfileViews from '../../components/dashboard/profile-views/HighSchoolProfileViews';
export default function ProfileViewsPage() {
    const { user } = useAppState();

    usePageRequireAuth({});

    const renderByRole = useCallback((role: Espin_Role_Enum) => {
        switch (role) {
            case Espin_Role_Enum.EspinParentUser:
                return <ParentProfileViews />;
            case Espin_Role_Enum.EspinPlayerUser:
                return <PlayerProfileViews />;
            case Espin_Role_Enum.EspinCollegeUser:
                return <CollegeProfileViews />;
            case Espin_Role_Enum.EspinHighschoolUser:
                return <HighSchoolProfileViews />;
        }
    }, []);
    if (!!!user) {
        return <DashboardFullPageLoading />;
    }

    return (
        <DashboardLayout pageTitle="Profile Views">
            <NeedsOnboardingInformation>{renderByRole(user.role)}</NeedsOnboardingInformation>
        </DashboardLayout>
    );
}
